import { ajax as request } from '@blade/common';
/**
*@Description: 日志导出
*@Date: 2020-09-01 14:39:57
*/
export const logExport = (data) => request({
    url: '/api/user-management/api/v1/logs/export',
    method: 'POST',
    data
});
/**
*@Description: 日志登录查询
*@Date: 2020-09-01 14:39:57
*/
export const getLogLoginList = (data) => request({
    url: '/api/user-management/api/v1/logs/login_log',
    method: 'POST',
    data
});
/**
*@Description: 日志操作查询
*@Date: 2020-09-01 14:39:57
*/
export const getLogOpList = (data) => request({
    url: '/api/user-management/api/v1/logs/op_log',
    method: 'POST',
    data
});
export const getLogNames = () => request({
    url: '/api/user-management/api/v1/logs/op_log/names',
    method: 'GET',
});
/**
*@Description: 日志测试
*@Date: 2020-09-01 14:39:57
*/
export const getDevicesDetail = (data) => request({
    url: '/api/user-management/api/v1/logs/task_log',
    method: 'POST',
    data
});
export const taskLog = (fileName) => request({
    url: `/api/user-management/api/v1/log/taskLog/${fileName}`,
    method: 'GET',
});
